/**
 * Phase COI-PREVIEW Defect-fix — canonical "is a COI on file for this
 * rental" predicate. Used by ``AdminRentalDetailPage`` to gate the
 * resend / replace UI.
 *
 * Why a dedicated helper:
 *   * Phase ICR's older initial-import path did NOT always set
 *     ``coi_request.has_response = true`` — it only set
 *     ``response_coi_path`` + ``response_coi_filename`` + the
 *     ``coi_imported_on_file`` history event. Rentals stuck in that
 *     shape were rendering the empty-state "No COI request yet" copy
 *     and hiding the Send/Resend button, even though a real COI file
 *     was actually attached on disk.
 *   * Today's COI-REPLACE flow writes ``has_response=true`` going
 *     forward, but older rentals are still in the field — so the
 *     predicate must accept any of the three signals.
 */
export function isCoiOnFile(coiRequest) {
    if (!coiRequest) return false;
    return Boolean(
        coiRequest.has_response
        || coiRequest.response_coi_path
        || coiRequest.response_coi_filename,
    );
}
